<!-- @veltra/icons generated sha256:114211b48e3e2436 gen:8 source:src/svg/normal/align-top.svg -->
<script setup lang="ts">
defineOptions({ name: 'AlignTop' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M2.5 2.496v8.008a.5.5 0 0 0 .504.496h.011c.276 0 .485-.22.485-.496V2.496A.5.5 0 0 0 2.996 2h-.011a.484.484 0 0 0-.485.496M6 13.494V2.506C6 2.23 6.209 2 6.485 2h.011c.276 0 .504.23.504.506v10.988a.49.49 0 0 1-.485.506h-.011A.51.51 0 0 1 6 13.494m3.5-2.99V2.496c0-.276.209-.496.485-.496h.011a.5.5 0 0 1 .504.496v8.008a.484.484 0 0 1-.485.496h-.011a.5.5 0 0 1-.504-.496m3.5 2.99V2.506c0-.276.209-.506.485-.506h.011c.276 0 .504.23.504.506v10.988a.51.51 0 0 1-.504.506h-.011a.49.49 0 0 1-.485-.506"
    />
  </svg>
</template>
